<template>
  <div>
    <el-card style="margin-bottom: 20px">
      <el-form :model="query" inline>
        <el-form-item label="状态">
          <el-select v-model="query.certStatus" placeholder="请选择" clearable>
            <el-option label="待审核" value="REVIEWING"></el-option>
            <el-option label="已通过" value="APPROVED"></el-option>
            <el-option label="已驳回" value="REJECTED"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card>
      <el-table :data="list" border stripe v-loading="loading">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="userNickname" label="用户昵称" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="realName" label="真实姓名" width="100"></el-table-column>
        <el-table-column prop="certType" label="认证类型" width="100">
          <template slot-scope="{ row }">
            {{ row.certType === 'BUSINESS' ? '机构认证' : '牛人认证' }}
          </template>
        </el-table-column>
        <el-table-column prop="idCardNo" label="身份证号" width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="businessName" label="企业名称" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="contactMobile" label="联系电话" width="130"></el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="{ row }">
            <el-tag :type="row.certStatus === 'APPROVED' ? 'success' : row.certStatus === 'REJECTED' ? 'danger' : 'warning'" size="small">
              {{ row.certStatus === 'APPROVED' ? '已通过' : row.certStatus === 'REJECTED' ? '已驳回' : '待审核' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="rejectReason" label="驳回原因" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="auditTime" label="审核时间" width="160"></el-table-column>
        <el-table-column prop="createTime" label="申请时间" width="160"></el-table-column>
        <el-table-column label="操作" width="220" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleDetail(row)">详情</el-button>
            <template v-if="row.certStatus === 'REVIEWING'">
              <el-button type="text" style="color: #67C23A" @click="handleApprove(row)">通过</el-button>
              <el-button type="text" style="color: #F56C6C" @click="handleReject(row)">驳回</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 20px; text-align: right"
        :current-page="query.page"
        :page-sizes="[10, 20, 50]"
        :page-size="query.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next"
        @size-change="val => { query.pageSize = val; fetchList() }"
        @current-change="val => { query.page = val; fetchList() }"
      ></el-pagination>
    </el-card>

    <!-- 详情弹窗 -->
    <el-dialog title="认证详情" :visible.sync="detailVisible" width="760px">
      <el-descriptions border :column="1" v-if="currentItem">
        <el-descriptions-item label="用户昵称">{{ currentItem.userNickname || '-' }}</el-descriptions-item>
        <el-descriptions-item label="认证类型">{{ currentItem.certType === 'BUSINESS' ? '机构认证' : '牛人认证' }}</el-descriptions-item>
        <el-descriptions-item label="真实姓名">{{ currentItem.realName }}</el-descriptions-item>
        <el-descriptions-item label="身份证号">{{ currentItem.idCardNo }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{ currentItem.contactMobile || '-' }}</el-descriptions-item>
        <el-descriptions-item label="企业名称">{{ currentItem.businessName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="营业执照号">{{ currentItem.businessLicenseNo || '-' }}</el-descriptions-item>
        <el-descriptions-item label="企业地址">{{ currentItem.businessAddress || '-' }}</el-descriptions-item>
        <el-descriptions-item label="状态">{{ currentItem.certStatus === 'APPROVED' ? '已通过' : currentItem.certStatus === 'REJECTED' ? '已驳回' : '待审核' }}</el-descriptions-item>
        <el-descriptions-item label="驳回原因" v-if="currentItem.rejectReason">{{ currentItem.rejectReason }}</el-descriptions-item>
        <el-descriptions-item label="身份证正面照" v-if="currentItem.idCardFrontUrl">
          <el-image
            class="cert-image"
            :src="currentItem.idCardFrontUrl"
            :preview-src-list="[currentItem.idCardFrontUrl]"
            fit="cover"
          ></el-image>
        </el-descriptions-item>
        <el-descriptions-item label="身份证背面照" v-if="currentItem.idCardBackUrl">
          <el-image
            class="cert-image"
            :src="currentItem.idCardBackUrl"
            :preview-src-list="[currentItem.idCardBackUrl]"
            fit="cover"
          ></el-image>
        </el-descriptions-item>
        <el-descriptions-item label="营业执照" v-if="currentItem.businessLicenseUrl">
          <el-image
            class="cert-image"
            :src="currentItem.businessLicenseUrl"
            :preview-src-list="[currentItem.businessLicenseUrl]"
            fit="cover"
          ></el-image>
        </el-descriptions-item>
        <el-descriptions-item label="技能资质图片" v-if="getSkillQualificationImages(currentItem).length">
          <div class="cert-image-grid">
            <el-image
              v-for="(url, idx) in getSkillQualificationImages(currentItem)"
              :key="`${url}-${idx}`"
              class="cert-image cert-image-multi"
              :src="url"
              :preview-src-list="getSkillQualificationImages(currentItem)"
              :initial-index="idx"
              fit="cover"
            ></el-image>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="审核人ID">{{ currentItem.auditUserId || '-' }}</el-descriptions-item>
        <el-descriptions-item label="审核时间">{{ currentItem.auditTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="申请时间">{{ currentItem.createTime }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ currentItem.updateTime || '-' }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>

    <el-dialog title="驳回认证" :visible.sync="rejectVisible" width="520px" @close="resetRejectForm">
      <el-form :model="rejectForm" label-width="80px">
        <el-form-item label="驳回原因" required>
          <el-input
            v-model="rejectForm.reason"
            type="textarea"
            :rows="4"
            maxlength="200"
            show-word-limit
            placeholder="请输入驳回原因，用户可据此修改后重新提交"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="rejectVisible = false">取消</el-button>
        <el-button type="primary" @click="submitReject">确定驳回</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getCertifications, getCertificationDetail, approveCertification, rejectCertification } from '../../api'

export default {
  name: 'CertificationManage',
  data() {
    return {
      query: { certStatus: '', page: 1, pageSize: 10 },
      list: [],
      total: 0,
      loading: false,
      detailVisible: false,
      currentItem: null,
      rejectVisible: false,
      rejectTarget: null,
      rejectForm: {
        reason: ''
      }
    }
  },
  created() { this.fetchList() },
  methods: {
    fetchList() {
      this.loading = true
      getCertifications(this.query).then(res => {
        this.list = res.data.records || res.data || []
        this.total = res.data.total || 0
      }).finally(() => { this.loading = false })
    },
    search() { this.query.page = 1; this.fetchList() },
    reset() { this.query = { certStatus: '', page: 1, pageSize: 10 }; this.fetchList() },
    handleDetail(row) {
      getCertificationDetail(row.id).then(res => {
        this.currentItem = res.data
        this.detailVisible = true
      })
    },
    handleApprove(row) {
      this.$confirm('确定要通过该认证申请吗？', '提示', { type: 'info' }).then(() => {
        approveCertification(row.id).then(() => {
          this.$message.success('已通过')
          this.fetchList()
        })
      }).catch(() => {})
    },
    handleReject(row) {
      this.rejectTarget = row
      this.rejectForm.reason = row.rejectReason || ''
      this.rejectVisible = true
    },
    resetRejectForm() {
      this.rejectTarget = null
      this.rejectForm.reason = ''
    },
    submitReject() {
      if (!this.rejectTarget) return
      if (!this.rejectForm.reason || !this.rejectForm.reason.trim()) {
        this.$message.warning('请输入驳回原因')
        return
      }
      rejectCertification(this.rejectTarget.id, { reason: this.rejectForm.reason.trim() }).then(() => {
        this.$message.success('已驳回')
        this.rejectVisible = false
        this.resetRejectForm()
        this.fetchList()
      })
    },
    getSkillQualificationImages(item) {
      if (!item || !item.skillQualificationImageUrls) return []
      if (Array.isArray(item.skillQualificationImageUrls)) {
        return item.skillQualificationImageUrls.filter(Boolean)
      }
      if (typeof item.skillQualificationImageUrls === 'string') {
        const text = item.skillQualificationImageUrls.trim()
        if (!text) return []
        if (text.startsWith('[')) {
          try {
            const parsed = JSON.parse(text)
            if (Array.isArray(parsed)) {
              return parsed.filter(Boolean)
            }
          } catch (e) {
            // fall through to delimiter split
          }
        }
        return text.split(/[\n,，]/).map(url => url.trim()).filter(Boolean)
      }
      return []
    }
  }
}
</script>

<style scoped>
.cert-image {
  width: 120px;
  height: 120px;
  border-radius: 10px;
  border: 1px solid #ebeef5;
  background: #f7f8fa;
  overflow: hidden;
}

.cert-image-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.cert-image-multi {
  width: 110px;
  height: 110px;
}
</style>
